import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CHANGE_PASSWORD_FORM", {
  PASSWORD: "Password",
  CONFIRM_PASSWORD: "Confirm password",
  SUBMIT_BUTTON: "Submit",
});
